module.exports = __webpack_public_path__ + "static/img/baas_channel_3.94906e2.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/baas_channel_3.svg
// module id = btF6
// module chunks = 0